import { Provider } from '@angular/core';
import {
  GetAuditLogTaskNamesUseCase,
  GetConfigurationAuditLogDetailsUseCase,
} from '@app/application/use-cases/configuration-audit-log';
import { GetConfigurationAuditLogUseCase } from '@app/application/use-cases/configuration-audit-log/get-configuration-audit-log.use-case';
import { ConfigurationAuditLogRepository } from '@app/domain';
import { ConfigurationAuditLogRepositoryImpl } from '../repositories';

export const CONFIGURATION_AUDIT_LOG_PROVIDERS: Provider[] = [
  {
    provide: ConfigurationAuditLogRepository,
    useClass: ConfigurationAuditLogRepositoryImpl,
  },
  {
    provide: GetConfigurationAuditLogUseCase,
    useFactory: (repo: ConfigurationAuditLogRepository) =>
      new GetConfigurationAuditLogUseCase(repo),
    deps: [ConfigurationAuditLogRepository],
  },
  {
    provide: GetConfigurationAuditLogDetailsUseCase,
    useFactory: (repo: ConfigurationAuditLogRepository) =>
      new GetConfigurationAuditLogDetailsUseCase(repo),
    deps: [ConfigurationAuditLogRepository],
  },
  {
    provide: GetAuditLogTaskNamesUseCase,
    useFactory: (repo: ConfigurationAuditLogRepository) =>
      new GetAuditLogTaskNamesUseCase(repo),
    deps: [ConfigurationAuditLogRepository],
  },
];
